// StoreHours.tsx
import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useStoreHoursLogic } from "../Logic/BusinessEmployees";
import { BusinessEmployeeFormUI } from "../UI/BusinessEmployees";

export const StoreHours: React.FC = () => {
  const {
    employees,
    showAddForm,
    handleAddEmployee,
    handleUpdateEmployee,
    handleDeleteEmployee,
    toggleAddForm,
    availableServices,
    handleFileUpload,
  } = useStoreHoursLogic();

  const [dataReady, setDataReady] = useState(false);

  useEffect(() => {
    if (Array.isArray(employees) && !dataReady) {
      setDataReady(true);
    }
  }, [employees]);

  if (!dataReady) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="400px">
        <CircularProgress />
      </Box>
    );
  }
  return (
    <BusinessEmployeeFormUI
      ALL_AVAILABLE_SERVICES={availableServices}
      employees={employees}
      showAddForm={showAddForm}
      toggleAddForm={toggleAddForm}
      handleAddEmployee={handleAddEmployee}
      handleUpdateEmployee={handleUpdateEmployee}
      handleDeleteEmployee={handleDeleteEmployee}
      onFileUpload={handleFileUpload}
    />
  );
};

export default StoreHours;
